/**
 * Service: themesApi
 */
angular.module('acme.common.service.themesApi', [
  'acme.common.factory.apiVersion',
  'acme.common.factory.QueryStringBuilder'
])
.service('ThemesApiService', [ '$http', 'ApiVersionFactory', 'QueryStringBuilderFactory', function($http, ApiVersionFactory, QueryStringBuilderFactory) {

    return {

      service: '',

      init: function(endpoint) {
        this.service = endpoint + '/themes';
        return this;
      },

      detail: function(includeEmail) {
        var q = '',
            av = new ApiVersionFactory();

        if (includeEmail) {
          var qs = new QueryStringBuilderFactory({
            props: { includeEmail: true },
            fields: {
              optional: ['includeEmail']
            }
          });
          q = qs.query;
        }

        return $http({
          method: 'get',
          url: av.init({ url: this.service + q, version: 'v2' })
        });

      },

      update: function(props) {
        var av = new ApiVersionFactory();

        return $http({
          method: 'put',
          url: av.init({ url: this.service, version: 'v2' }),
          data: {
            variables: props.variables,
            textVariables: props.textVariables,
            links: props.links,
            emailVariables: props.emailVariables,
            membershipConfig: props.membershipConfig,
            customScripts: props.customScripts
          }
        });

      },

      updateEmail: function(props) {
        var q = '',
            av = new ApiVersionFactory();

        var qs = new QueryStringBuilderFactory({
          props: { emailOnly: true },
          fields: {
            optional: ['emailOnly']
          }
        });
        q = qs.query;

        return $http({
          method: 'put',
          url: av.init({ url: this.service + q, version: 'v2' }),
          data: {
            emailVariables: props.emailVariables
          }
        });
      },

      remove: function() {
        var av = new ApiVersionFactory();

        return $http({
          method: 'delete',
          url: av.init({ url: this.service, version: 'v2' })
        });
      },

      getTicketConfig: function() {
        var av = new ApiVersionFactory();

        return $http({
          method: 'get',
          url: av.init({ url: this.service + '/tickets', version: 'v2' })
        });
      },

      updateTicketConfig: function(props) {
        var av = new ApiVersionFactory();

        return $http({
          method: 'put',
          url: av.init({ url: this.service + '/tickets', version: 'v2' }),
          data: {
            ticketConfig: props.ticketConfig
          }
        });
      },

      getMembershipConfig: function() {
        var av = new ApiVersionFactory();

        return $http({
          method: 'get',
          url: av.init({ url: this.service + '/membership', version: 'v2' })
        });
      },

      updateMembershipConfig: function(props) {
        var av = new ApiVersionFactory();

        return $http({
          method: 'put',
          url: av.init({ url: this.service + '/membership', version: 'v2' }),
          data: {
            membershipConfig: props.membershipConfig
          }
        });
      }

    };

}]);